<template>
    <div
        class="modal fade"
        id="select-stamp"
        tabindex="-1"
        data-backdrop="static"
        data-keyboard="false"
        aria-labelledby="select-stamp"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="p-4">
                        <div class="d-flex justify-center pb-2">
                            <h2 id="select-stamp" class="font-32">SELECIONE UM CARIMBO</h2>
                        </div>
                        <div class="w-full">
                            <div class="flex flex-col gap-4">
                                <div 
                                    class="stamp-card"
                                    v-for="(stamp, index) in stamps"
                                    :key="index"
                                    @click="SelectStamp(stamp)"
                                >
                                    <div class="flex items-center">
                                        <div class="visual-stamp-wrapper">
                                            <div class="visual-stamp-preview">
                                                <div class="stamp-line-preview" v-html="stamp.line_one"></div>
                                                <div class="stamp-line-preview" v-html="stamp.line_two"></div>
                                                <div class="stamp-line-preview" v-html="stamp.line_three"></div>
                                            </div>
                                            <div class="visual-signature-preview relative overflow-hidden">
                                                <img 
                                                    v-if="stamp.signature_url" 
                                                    :src="stamp.signature_url" 
                                                    alt="signature" 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex items-center">
                                        <span v-if="stamp.professional_advice && !stamp.uf_professional_advice" class="card-label">{{stamp.professional_advice_description}} - :</span>
                                        <span v-else-if="stamp.professional_advice && stamp.uf_professional_advice" class="card-label">{{stamp.professional_advice_description}} - {{ stamp.uf_professional_advice }} :</span>
                                        <span class="card-value"><strong>{{ stamp.number || '-' }}</strong></span> 
                                    </div>
                                    <div class="flex items-center">
                                        <span v-if="stamp.rqe && stamp.uf_rqe" class="card-label">RQE - {{ stamp.uf_rqe }} :</span>
                                        <span v-else-if="stamp.rqe && !stamp.uf_rqe" class="card-label">RQE - :</span>
                                        <span class="card-value"><strong>{{ stamp.rqe || '-' }}</strong></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'SelectStamp',
    props: {
        open: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters('auth', [
            'account', 'requesters', 'requester_selected_id', 'is_registered', 'subscription_info', 'stamps', 'selected_stamp', 'requester_needs_stamp_selection'
        ]),
    },
    watch: {
        'open': {
            handler(val) {
                window.jQuery('#select-stamp').modal((val ? 'show' : 'hide'))
            },
            immediate: true
        }
    },
    methods: {
        ...mapActions('auth', [
            'SetRequesterAccount', 'GetAuthAccount', 'GetSubscriptionInfo', 'IsRegistered', 'SetSelectedStamp'
        ]),
        async SelectStamp(stamp) {
            await this.SetSelectedStamp({
                stamp, 
                requester_id: this.requester_selected_id 
            })

            this.$emit('selected', stamp)

            this.Close()
        },
        Close() {
            window.jQuery('#select-stamp').modal('hide')

			this.$emit('close')
        }
    },
    async mounted() {
        if(this.requester_needs_stamp_selection) {
            window.jQuery('#select-stamp').modal('show')
        } else {
            window.jQuery('#select-stamp').modal('hide')
        }

        document.addEventListener('keyup', e => {
            if(e.keyCode === 27 && this.selected_stamp) {
                this.Close()
            }
        })
    }
}
</script>

<style lang="scss" scoped>
.modal-dialog {
    width: 90%;
    max-width: 90%;
}

.stamp-card {
	background-color: var(--gridBackgroundColor);
	border: 1px solid var(--newPrimaryBackgroundColor);
	transition: background-color 0.1s;
	min-height: 5rem;
	width: 100%;
	display: grid;
	grid-template-columns: 3.5fr 1.5fr 1.5fr 1fr;
	align-items: center;
	padding: 0.625rem 0.75rem;
	cursor: pointer;
	border-radius: 0.5rem;
	font-family: 'Avenir Next', sans-serif !important;

	.visual-stamp-wrapper {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		gap: 0.625rem;
		width: 100%;

		.visual-stamp-preview, .visual-signature-preview {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			background-color: var(--gridBackgroundColor) !important;
			color: var(--textColor);
			height: 3.313rem;
			width: 9rem;
			overflow: hidden;
			border-radius: 0.25rem;
			border: 1px solid var(--textColor) !important;
			flex-shrink: 0;
			transition: color 0.1s, border-color 0.1s;

			img {
				display: block;
				width: 100%;
				height: 100%;
				object-fit: contain;
			}

			.stamp-line-preview {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				text-transform: uppercase;
				line-height: 1;
				max-height: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				width: 100%;
				padding: 0;
				box-sizing: border-box;
			}
		}
	}

	.card-label {
		color: var(--textColor);
		font-size: 0.938rem;
		font-weight: 300;
		margin-right: 0.375rem;
	}

	.card-value {
		color: var(--textColor);
		font-size: 1rem;
		white-space: nowrap;
		font-weight: bold;
	}
}
</style>
